"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: {
    value: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: 10
    },
    placeholder: {
      type: String,
      default: '请输入内容'
    }
  },
  data: function data() {
    return {
      val: ''
    };
  },
  mounted: function mounted() {
    this.val = this.value;
  },
  methods: {
    submit: function submit() {
      this.$emit('submit', this.val);
    }
  }
};
exports.default = _default;